import React from 'react';
import PropTypes from 'prop-types';
import ReactPlayer from 'react-player';
import { Card, CardBody, CardHeader, Col, Row, Form } from 'reactstrap';
import InputGroup from '../../../../components/cms/form/inputGroup';
import SubmitButtons from '../../../../components/cms/form/submitButtons';
import MlFields from '../../../../components/cms/form/mlFields';
import InputFile from '../../../../components/cms/form/inputFile';
import PreviewImage from '../../../../components/previewImage';

const twoCols = { xs: 12, md: 6 };

const Slide = ({
  t,
  onChange,
  onSubmit,
  errors,
  formData,
  videoUrl,
  title,
  isSubmitting,
  isSubmittingRedirect,
  onChangeMl,
  imageSrc,
}) => (
  <div>
    <Card>
      <CardHeader>
        <strong><i className="fa fa-edit pr-2" />{title}</strong>
      </CardHeader>
      <CardBody>
        <Form onSubmit={onSubmit(true)}>
          <Row>
            <Col {...twoCols}>
              <div>
                <InputFile id="image" label={t('Image')}>
                  <PreviewImage src={imageSrc} alt="img" height="120" />
                </InputFile>
              </div>
              <div>
                <InputFile id="video" label={t('Video')} />
                {videoUrl && (<ReactPlayer url={videoUrl} controls className="mb-2 mt-1" />)}
              </div>
            </Col>
            <Col {...twoCols}>
              <InputGroup
                name="status"
                label={t('Status')}
                onChange={onChange}
                errors={errors}
                type="checkbox"
                value={1}
                checked={formData.status}
              />
              <InputGroup
                name="priority"
                label={t('Priority')}
                onChange={onChange}
                errors={errors}
                value={formData.priority}
                icon="fa fa-link"
              />
            </Col>
          </Row>

          <MlFields
            onChange={onChangeMl}
            formData={formData}
            fields={props => (
              <div>
                <Row>
                  <Col {...twoCols}>
                    <InputGroup
                      name="title"
                      label={t('Title')}
                      errors={errors}
                      onChange={props.onChange}
                      formData={props.formData}
                      icon="fa fa-pencil-square-o"
                    />
                  </Col>
                  <Col {...twoCols}>
                    <InputGroup
                      name="subtitle"
                      label={t('Subtitle')}
                      errors={errors}
                      onChange={props.onChange}
                      formData={props.formData}
                      icon="fa fa-pencil-square-o"
                    />
                  </Col>
                </Row>
                <InputGroup
                  name="url"
                  label={t('Url')}
                  errors={errors}
                  onChange={props.onChange}
                  formData={props.formData}
                  icon="fa fa-link"
                />
              </div>
            )}
          />
          <Row>
            <Col md={12}>
              <SubmitButtons
                isSubmitting={isSubmitting}
                onSubmit={onSubmit}
                isSubmittingRedirect={isSubmittingRedirect}
              />
            </Col>
          </Row>
        </Form>
      </CardBody>
    </Card>
  </div>
);

Slide.propTypes = {
  t: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  isSubmittingRedirect: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  formData: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  videoUrl: PropTypes.string.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
};

export default Slide;



// WEBPACK FOOTER //
// ./src/views/content/slides/slide/Slide.jsx